import { useEffect } from "react";

/**
 * Single source of truth for fullscreen modal/overlay behavior:
 * - Locks body scroll while open
 * - Closes on ESC key (capture phase, so it always wins over child handlers)
 *
 * Usage:
 *   useModalLock(isOpen, onClose);
 */
export function useModalLock(isOpen: boolean, onClose: () => void) {
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", onKey, { capture: true });

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKey, { capture: true } as any);
    };
  }, [isOpen, onClose]);
}
